module.exports = __webpack_public_path__ + "static/media/nova.a149ad33.png";